import { render, staticRenderFns } from "./CoozzyFavoriteIcon.vue?vue&type=template&id=fc1c6864&scoped=true"
import script from "./CoozzyFavoriteIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyFavoriteIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyFavoriteIcon.vue?vue&type=style&index=0&id=fc1c6864&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc1c6864",
  null
  
)

export default component.exports